import request from '@/utils/request'

// 上架规则
export const publish = (alarmRulesId)=>{
  return request({
    url: '/admin-api/client/pc/alarm-rules/publish',
    method: 'get',
    params: {alarmRulesId: alarmRulesId}
  })
}

// 下架规则
export const unpublish = (alarmRulesId)=>{
  return request({
    url: '/admin-api/client/pc/alarm-rules/unpublish',
    method: 'get',
    params: {alarmRulesId: alarmRulesId}
  })
}



// 告警规则分页
export const alarmList = (params)=>{
  return request({
    url: '/admin-api/client/pc/alarm-rules/page',
    method: 'get',
    params: params
  })
}

// 新增告警规则
export const addAlarm = (data)=>{
  return request({
    url: '/admin-api/client/pc/alarm-rules/create',
    method: 'post',
    data: data
  })
}
// 获得告警规则
export const getAlarmDetail = (params)=>{
  return request({
    url: '/admin-api/client/pc/alarm-rules/get',
    method: 'get',
    params: params
  })
}

// 更新规则
export const updateAlarm = (data) => {
  return request({
    url: '/admin-api/client/pc/alarm-rules/update',
    method: 'put',
    data: data,
  })
}


